<template>

  <Modal
    :title="$t('Gerador de job description - ChatGPT')"
    @close="cancel"
    min-height="300px"
    :max-width="isFilled ? '940px' : '540px'">
    <template slot="body">
      
      <div
        :class="{ row: isFilled }"
        style="width: 100%;">
        <div
          v-if="isFilled"
          class="col-6">
          <h6 class="mb-3">Descrição atual</h6>
          <div
            v-if="value"
            class="card">
            <div class="card-header">
              {{ $t('Description') }}
            </div>
            <div class="card-body">
              <div v-html="value.description"></div>
            </div>
            <div class="card-header">
              {{ $t('Requirements') }}
            </div>
            <div class="card-body">
              <div v-html="value.requirements"></div>
            </div>
            <div class="card-header">
              {{ $t('Benefits') }}
            </div>
            <div class="card-body">
              <div v-html="value.benefits"></div>
            </div>
          </div>
        </div>
        <div
          :class="{ 'col-6': isFilled }">
          <h6 class="mb-3">{{ $t('New description') }}</h6>
          <JobModalDescriptionForm
            v-show="!job_description"
            :value="value"
            @input="setJobDescription" />
          <div
            v-if="job_description">
            <div class="card">
              <div class="card-header">
                {{ $t('Description') }}
              </div>
              <div>
                <textarea-editable
                  v-model="job_description.description"
                  editor-model="html"
                  :enable-link="true"
                  :enable-img="true"></textarea-editable>
              </div>
              <div class="card-header">
                {{ $t('Requirements') }}
              </div>
              <div>
                <textarea-editable
                  v-model="job_description.requirements"
                  editor-model="html"
                  :enable-link="true"
                  :enable-img="true"></textarea-editable>
              </div>
              <div class="card-header">
                {{ $t('Benefits') }}
              </div>
              <div>
                <textarea-editable
                  v-model="job_description.benefits"
                  editor-model="html"
                  :enable-link="true"
                  :enable-img="true"></textarea-editable>
              </div>
            </div>
            <button
              type="button"
              class="btn btn-outline-primary mt-3"
              @click="job_description = null">{{ $t('Gerar outro job description') }}</button>
          </div>
        </div>
      </div>


    </template>
    <template
      slot="footer">
      <div
        :class="{'box-loading': loading}">
        <button
          type="button"
          class="btn btn-light"
          @click="cancel">{{ $t('Cancel') }}</button>
        <button
          v-if="job_description"
          type="button"
          class="btn btn-primary"
          @click="save">{{ $t('Aplicar descrição na vaga') }}</button>
      </div>
    </template>
  </Modal>

</template>

<script>
import Modal from '@/components/Modal/Modal'
import JobModalDescriptionForm from './JobModalDescriptionForm'

export default {
  name: 'JobForm',
  components: {
    Modal,
    JobModalDescriptionForm
  },
  props: {
    'value': {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      loading: false,
      job_description: null
    }
  },
  computed: {
    isFilled () {
      return this.value.description && this.value.requirements && this.value.benefits
    }
  },
  watch: {
  },
  created () {
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    setJobDescription (value) {
      this.job_description = value
    },
    save () {
      this.$emit('input', this.job_description)
      this.cancel()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/JobForm/JobModalDescription.vue